import { render, staticRenderFns } from "./BrandFormAddress.vue?vue&type=template&id=063d9098&"
import script from "./BrandFormAddress.vue?vue&type=script&lang=js&"
export * from "./BrandFormAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports